import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RotatingBadgeProps {
    id: string
    text: string
    className?: string
    children?: ReactNode
}

// Circular sticker with text running around its edge. `id` must be unique on the page.
const RotatingBadge: FC<RotatingBadgeProps> = ({ id, text, className, children }): ReactNode => {
    const pathId = `${id}-circle`

    return (
        <span className={cn('relative grid place-items-center rounded-full', className)}>
            <svg
                viewBox='0 0 200 200'
                aria-hidden='true'
                focusable='false'
                className='absolute inset-0 size-full motion-safe:animate-spin-slow'
            >
                <defs>
                    <path id={pathId} d='M 100,100 m -76,0 a 76,76 0 1,1 152,0 a 76,76 0 1,1 -152,0' />
                </defs>

                <text className='fill-current font-mono' fontSize='15' letterSpacing='2.2'>
                    <textPath href={`#${pathId}`}>
                        {text}
                    </textPath>
                </text>
            </svg>

            {children}
        </span>
    )
}

export default RotatingBadge
